import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "分类", to: "/category/1990s" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
    setMenuOpen(false);
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to.split("?")[0]);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-300/70 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-3 md:h-[68px]">
          <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2.5" onClick={() => setMenuOpen(false)}>
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">香港三级片</span>
              <span className="mt-0.5 text-[10px] uppercase tracking-[0.2em] text-secondary-600">Category III Archive</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden items-center md:flex">
            <div className="flex items-center overflow-hidden rounded-full border border-background-300 bg-background-50 focus-within:border-primary-400">
              <span className="flex h-9 w-9 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" />
              </span>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                type="search"
                name="site_search"
                placeholder="搜索片名 / 导演 / 关键词"
                className="h-9 w-56 bg-transparent pr-1 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="m-0.5 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索
              </button>
            </div>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-300/70 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={handleSearch} className="mb-4 flex items-center overflow-hidden rounded-full border border-background-300 bg-background-100">
            <span className="flex h-10 w-10 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" />
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="search"
              name="site_search_mobile"
              placeholder="搜索片名 / 导演 / 关键词"
              className="h-10 flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="m-1 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-xs font-medium text-background-50"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`cursor-pointer rounded-md px-3.5 py-2.5 text-sm font-medium ${
                  isActive(item.to) ? "bg-primary-100 text-primary-700" : "text-foreground-800 hover:bg-background-200"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}